import { useCallback, useState } from 'react';
import { getMe, resendConfirmation } from '../api';

// Этап W1 (вариант B): «турникет» подтверждения e-mail внутри Telegram Mini App.
// Жёсткий гейтинг резервного канала: пока почта не подтверждена по ссылке из
// письма, в сервис не пускаем (даже при валидном входе через Telegram).
// Показывается клиенту после регистрации; staff/франшизу не блокируем (их
// аккаунты заводит Админ, e-mail-верификация для них не предусмотрена).
export default function EmailVerifyGatePage({ email, onVerified }: { email: string | null; onVerified: () => void }) {
  const [checking, setChecking] = useState(false);
  const [stillUnverified, setStillUnverified] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState<string | null>(null);

  const recheck = useCallback(async () => {
    if (checking) return;
    setChecking(true);
    setStillUnverified(false);
    try {
      const { data } = await getMe();
      if (data.email_verified) onVerified();
      else setStillUnverified(true);
    } catch {
      setStillUnverified(true);
    } finally {
      setChecking(false);
    }
  }, [checking, onVerified]);

  const resend = useCallback(async () => {
    if (resending) return;
    setResending(true);
    setResendMsg(null);
    try {
      const { data } = await resendConfirmation();
      if (data.already_verified) {
        onVerified();
        return;
      }
      setResendMsg(data.message || 'Письмо отправлено повторно.');
    } catch {
      setResendMsg('Не удалось отправить письмо. Попробуйте позже.');
    } finally {
      setResending(false);
    }
  }, [resending, onVerified]);

  return (
    <div className="container" style={{ padding: '28px 16px 40px', maxWidth: 560, margin: '0 auto' }}>
      <h2 style={{ margin: '0 0 8px', fontSize: 20, color: 'var(--tg-text)' }}>
        Подтвердите e-mail
      </h2>
      <p style={{ margin: '0 0 16px', fontSize: 14, lineHeight: 1.5, color: 'var(--tg-text)' }}>
        Мы отправили письмо{email ? <> на <b>{email}</b></> : ''}. Перейдите по ссылке из письма,
        чтобы завершить регистрацию.
      </p>
      <p style={{ margin: '0 0 20px', fontSize: 13, lineHeight: 1.45, color: 'var(--tg-hint)' }}>
        E-mail нужен для входа при проблемах с Telegram и для системных уведомлений.
      </p>

      {stillUnverified && (
        <div style={{ background: '#ff3b3015', border: '1px solid #ff3b30', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 14, color: '#ff3b30' }}>
          Пока не видим подтверждения. Откройте ссылку из письма и попробуйте снова.
        </div>
      )}

      <button
        onClick={recheck}
        disabled={checking}
        style={{
          width: '100%',
          padding: '14px 0',
          border: 'none',
          borderRadius: 12,
          background: checking ? 'var(--tg-secondary-bg)' : 'var(--tg-button)',
          color: checking ? 'var(--tg-hint)' : 'var(--tg-button-text)',
          fontSize: 15,
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: checking ? 'not-allowed' : 'pointer',
          transition: 'background 0.15s',
        }}
      >
        {checking ? 'Проверяем…' : 'Я подтвердил — обновить'}
      </button>

      <button
        onClick={resend}
        disabled={resending}
        style={{
          width: '100%',
          marginTop: 10,
          padding: '13px 0',
          border: '1px solid var(--tg-button)',
          borderRadius: 12,
          background: 'transparent',
          color: 'var(--tg-button)',
          fontSize: 14,
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: resending ? 'not-allowed' : 'pointer',
          opacity: resending ? 0.6 : 1,
          transition: 'opacity 0.15s',
        }}
      >
        {resending ? 'Отправляем…' : 'Отправить письмо ещё раз'}
      </button>

      {resendMsg && (
        <p style={{ marginTop: 12, fontSize: 13, lineHeight: 1.45, textAlign: 'center', color: 'var(--tg-text)' }}>
          {resendMsg}
        </p>
      )}

      <p className="hint" style={{ marginTop: 14, fontSize: 12, lineHeight: 1.4, textAlign: 'center' }}>
        Письмо не пришло? Проверьте папку «Спам».
      </p>
    </div>
  );
}
